export interface DataRefreshFeedbackSummary {
  graphQLErrorOperationCount: number;
  networkErrorOperationCount: number;
}

export interface DataRefreshFeedbackScope {
  close: () => DataRefreshFeedbackSummary;
}

interface MutableDataRefreshFeedbackScope {
  token: symbol;
  graphQLErrorOperationCount: number;
  networkErrorOperationCount: number;
}

let activeScope: MutableDataRefreshFeedbackScope | null = null;

export const beginDataRefreshFeedbackScope = (): DataRefreshFeedbackScope => {
  const scope: MutableDataRefreshFeedbackScope = {
    token: Symbol('data-refresh-feedback'),
    graphQLErrorOperationCount: 0,
    networkErrorOperationCount: 0,
  };
  activeScope = scope;

  return {
    close: () => {
      if (activeScope?.token === scope.token) {
        activeScope = null;
      }

      return {
        graphQLErrorOperationCount: scope.graphQLErrorOperationCount,
        networkErrorOperationCount: scope.networkErrorOperationCount,
      };
    },
  };
};

export const captureDataRefreshFeedbackFailure = ({
  hasGraphQLErrors,
  hasNetworkError,
}: {
  hasGraphQLErrors: boolean;
  hasNetworkError: boolean;
}): boolean => {
  if (!activeScope || (!hasGraphQLErrors && !hasNetworkError)) {
    return false;
  }

  if (hasGraphQLErrors) {
    activeScope.graphQLErrorOperationCount += 1;
  }

  if (hasNetworkError) {
    activeScope.networkErrorOperationCount += 1;
  }

  return true;
};
